"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
// import { moderateScale, scale } from "../../utils/scale";
const CustomText_1 = __importDefault(require("../text/CustomText"));
const scale_1 = require("../../utils/scale");
const images_1 = require("../../assets/images");
const constants_1 = require("../../constants");
const NotiButton = ({ data, time, length }) => {
    const Icon = () => {
        if (data?.reactionType == 1) {
            return react_1.default.createElement(react_native_1.Image, { source: images_1.images?.FollowUse, style: styles.imageNoti });
        }
        else if (data?.reactionType == 2 || data?.reactionType == 4) {
            return react_1.default.createElement(react_native_1.Image, { source: images_1.images?.LikeTweet, style: styles.imageNoti });
        }
        else if (data?.reactionType == 3) {
            return react_1.default.createElement(react_native_1.Image, { source: images_1.images?.ReTweet, style: styles.imageNoti });
        }
        else if (data?.type == 2 && data?.userBulkNotificationId != null) {
            return react_1.default.createElement(react_native_1.Image, { source: images_1.images?.Tweet, style: styles.imageNoti });
        }
        else if (data?.reactionType == 5) {
            return react_1.default.createElement(react_native_1.Image, { source: images_1.images?.ArticleInh, style: styles.imageNoti });
        }
        else if ((data?.type == 3 || data?.type == 4) && data?.userBulkNotificationId != null) {
            return react_1.default.createElement(react_native_1.Image, { source: images_1.images?.postAritcle, style: styles.imageNoti });
        }
        return null;
    };
    const mainText = () => {
        if ((data?.type == 2 && (data?.reactionType == 3 || data?.reactionType == 2)) ||
            data?.reactionType == 5 ||
            data?.type == 1 ||
            data?.reactionType == 4) {
            if (data?.mainText?.includes('と他xx人')) {
                if (data?.others == 0) {
                    const replacedText = data?.mainText?.replace('と他xx人', '');
                    return replacedText;
                }
                else if (data?.others > 0) {
                    const replacedText = data?.mainText?.replace('と他xx人', `と他${data?.others}人`);
                    return replacedText;
                }
            }
        }
        return data?.mainText;
    };
    const checkComment = data?.reactionType == null && data?.userBulkNotificationId == null;
    const titleNoti = () => {
        if (data?.type == 2) {
            return 'タイムライン';
        }
        else if (data?.type == 3) {
            return '記事';
        }
        else if (data?.type == 1) {
            return 'アカウント';
        }
        else if (data?.type == 4) {
            return '自分史';
        }
        else if (data?.type == 9) {
            return '運営からのお知らせ';
        }
    };
    return (react_1.default.createElement(react_native_1.View, null,
        react_1.default.createElement(react_native_1.ImageBackground, { source: images_1.images.NotificationGroup, resizeMode: 'stretch', style: { width: (0, scale_1.scale)(352), marginLeft: (0, scale_1.scale)(-4.5) } },
            react_1.default.createElement(react_native_1.View, { style: [
                    styles.notification,
                    { backgroundColor: data?.isRead == 1 ? '#EDEDED' : undefined },
                ] },
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                        color: '#545454',
                        fontSize: (0, scale_1.moderateScale)(12),
                        marginBottom: (0, scale_1.scale)(8),
                    } }, titleNoti()),
                react_1.default.createElement(react_native_1.View, { style: styles.notiTitle },
                    checkComment && data?.type != 9 ? (react_1.default.createElement(react_native_1.View, { style: styles.notiTitleChild },
                        react_1.default.createElement(react_native_1.View, null,
                            react_1.default.createElement(react_native_1.Image, { source: data?.reactionUsers[0]?.thumbnailUrl
                                    ? data?.reactionUsers[0]?.thumbnailUrl
                                    : images_1.images.AvatarDefaul, style: {
                                    height: (0, scale_1.scale)(42),
                                    width: (0, scale_1.scale)(42),
                                    borderRadius: 99,
                                } })),
                        react_1.default.createElement(react_native_1.View, { style: { width: (0, scale_1.scale)(200) } },
                            react_1.default.createElement(CustomText_1.default, { weight: "300", style: [styles.textDes, { maxWidth: (0, scale_1.scale)(200) }], numberOfLines: 1 }, data?.reactionUsers[0]?.nickname || constants_1.DEFAULT_NAME),
                            react_1.default.createElement(CustomText_1.default, { weight: "300", style: [styles.textDate, { maxWidth: (0, scale_1.scale)(200) }], numberOfLines: 1 }, data?.reactionUsers[0]?.userHandle
                                ? `@${data?.reactionUsers[0]?.userHandle}`
                                : '')))) : (react_1.default.createElement(react_native_1.View, { style: styles.notiTitleChild },
                        react_1.default.createElement(Icon, null),
                        data?.reactionUsers?.map((item, index) => {
                            if (index >= 5)
                                return;
                            return (react_1.default.createElement(react_native_1.Image, { source: item?.thumbnailUrl
                                    ? item?.thumbnailUrl
                                    : images_1.images.AvatarDefaul, style: {
                                    height: (0, scale_1.scale)(32),
                                    width: (0, scale_1.scale)(32),
                                    borderRadius: 99,
                                } }));
                        }))),
                    react_1.default.createElement(CustomText_1.default, { weight: "300", style: [styles.textDate, { marginLeft: (0, scale_1.scale)(40) }] }, time)),
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: [
                        styles.textDes,
                        {
                            marginLeft: checkComment ? (0, scale_1.scale)(50) : 0,
                            marginBottom: checkComment ? (0, scale_1.moderateScale)(19) : 0,
                        },
                    ], numberOfLines: checkComment ? 1 : undefined }, checkComment ? data?.bottomText?.replace(/<[^>]*>/g, '') : mainText()),
                !checkComment && (react_1.default.createElement(CustomText_1.default, { weight: "300", style: styles.bottomText, numberOfLines: 1 }, data?.bottomText?.replace(/<[^>]*>/g, ''))),
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: [styles.bottomText, { paddingBottom: (0, scale_1.scale)(16) }] }, `その他${length}件の通知`)))));
};
const styles = react_native_1.StyleSheet.create({
    notification: {
        // position: "relative",
        padding: (0, scale_1.scale)(12),
        paddingHorizontal: (0, scale_1.scale)(14),
        marginBottom: (0, scale_1.scale)(22),
        borderTopLeftRadius: (0, scale_1.scale)(5),
        borderTopRightRadius: (0, scale_1.scale)(5),
        width: (0, scale_1.scale)(343)
    },
    notiTitle: {
        width: '100%',
        marginBottom: (0, scale_1.scale)(8),
        flexDirection: 'row',
        alignItems: 'center',
    },
    notiTitleChild: {
        flex: 1,
        height: (0, scale_1.scale)(32),
        flexDirection: 'row',
        alignItems: 'center',
        columnGap: (0, scale_1.scale)(8),
    },
    textTitle: {
        fontSize: (0, scale_1.moderateScale)(12),
        lineHeight: (0, scale_1.moderateScale)(18),
        color: '#292A33',
    },
    textDate: {
        fontSize: (0, scale_1.moderateScale)(10),
        lineHeight: (0, scale_1.moderateScale)(17),
        color: '#888888',
    },
    textDes: {
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
        color: '#292A33',
    },
    imageNoti: {
        width: (0, scale_1.scale)(32),
        height: (0, scale_1.scale)(32),
    },
    bottomText: {
        fontSize: (0, scale_1.moderateScale)(11),
        lineHeight: (0, scale_1.moderateScale)(19),
        color: '#999999',
    },
});
exports.default = NotiButton;
